import React, { FC, Fragment, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Container,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField
} from '@mui/material';
import styled from '@emotion/styled';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getEmployeeById,
  getEmployeeDesignationHistory,
  getEmployeeImagesById,
  getEmployeeManagers,
  updateEmployeeInformationProfile,
  uploadEmployeeImageById,
  getAllGenders,
  getAllMartialStatus
} from 'src/services/employeeService';
import {
  EmployeeDesignationHistory,
  UpdateEmployee,
  UpdateEmployeeProfile
} from 'src/models/employee';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Typography from '@mui/material/Typography';
import { SnackBar } from 'src/components/SnackBar';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import './Profile.css';
// import EmployeePromoteForm from './EmployeePromoteForm';
import { AppActions } from 'src/store/AppReducer';
import SortableTree from 'react-sortable-tree';
import { withStyles } from '@mui/styles';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from 'moment';
import MuiPhoneNumber from 'material-ui-phone-number';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import EmployeeProjectDetails from './EmployeeProjects';
import EmployeeLeaveSection from './EmployeeLeaveTab';
import ViewEventAttendee from './ViewEventAttendee';
import AcknowledgementTask from 'src/content/employeeOnboarding/PreOnboarding/components/AcknowledgementTask';

interface EmployeeEditProps {}

const ProfilePageAcknowledgementIntegration = (props: any) => {
  const orderedTaskList = (props.orderedTaskList as any[]) || [];
  const hasOnboardingStarted = props.hasOnboardingStarted ?? true;
  const permissions = props.permissions ?? [];

  const [isExpandAcknowledgement, setIsExpandAcknowledgement] =
    React.useState<boolean>(false);
  const [localSavingTaskId, setLocalSavingTaskId] = React.useState<
    number | null
  >(null);

  const ackTask =
    orderedTaskList.find((t) => t.name === 'Acknowledgement') ?? null;

  const timeLeftMap = props.timeLeftMap ?? {};

  const apiToLabel = (api?: string) => {
    switch ((api || '').toUpperCase()) {
      case 'TO_DO':
        return 'To Do';
      case 'IN_PROGRESS':
        return 'In Progress';
      case 'ON_HOLD':
        return 'On Hold';
      case 'COMPLETED':
        return 'Completed';
      default:
        return 'To Do';
    }
  };

  const checkDependency = (t: any) => {
    if (!t) return false;
    return false;
  };

  const computeReadOnly = (t: any) => {
    if (!t) return true;
    const currentStatus = (t.status || 'TO_DO').toUpperCase();
    const hasPerm = permissions?.some(
      (perm: any) => perm.name === t.name && perm.value === true
    );
    return !(
      hasPerm &&
      hasOnboardingStarted &&
      currentStatus !== 'COMPLETED' &&
      currentStatus !== 'ON_HOLD' &&
      !checkDependency(t)
    );
  };

  const handleSuccess = (msg: string) => {
    console.log('SUCCESS:', msg);
  };
  const handleError = (msg: string) => {
    console.error('ERROR:', msg);
  };

  const minimalOnSave = async (payload: {
    checked: Record<string, boolean>;
    comment: string;
  }) => {
    if (!ackTask) return;
    try {
      setLocalSavingTaskId(ackTask.id);

      await new Promise((res) => setTimeout(res, 600));

      handleSuccess('Acknowledgement saved (local simulation).');
    } catch (err) {
      handleError('Failed to save acknowledgement (local simulation).');
    } finally {
      setLocalSavingTaskId(null);
    }
  };
};

const ProfilePage: FC<EmployeeEditProps> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { employeeId } = useParams();
  let designationsInitial: EmployeeDesignationHistory[] = [];

  const [empName, setEmpName] = useState('');
  const [employeeInformation, setEmployeeInformation] = useState(
    {} as UpdateEmployee
  );

  const [emplyeeImages, setEmplyeeImages] = useState([]);

  const [genderValue, setGenderValue] = useState('');
  const [maritalStatusValue, setMaritalStatusValue] = useState('');

  const [genders, setAllGenders] = useState([]);
  const [maritalStatus, setAllMaritalStatus] = useState([]);

  const [designation, setEmployeeDesigntionHistory] =
    useState(designationsInitial);
  const [tableId, settableId] = useState('');
  const [reversedDesignation, setreversedDesignation] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const { register, handleSubmit, reset, setValue } = useForm<UpdateEmployee>();
  const tabIds: String[] = ['one', 'two', 'three', 'four', 'five'];
  const [isExpandAcknowledgement, setIsExpandAcknowledgement] =
    useState<boolean>(false);

  const getEmployeeImages = async () => {
    const result = await getEmployeeImagesById(employeeId);
    let images;
    if (result.data) {
      images = result.data.map((data) => {
        const image = `data:${data.type};base64,${data.base64Value}`;
        return {
          image: image,
          id: data.id
        };
      });

      setEmplyeeImages(images);
    }
  };

  const getEmplyeeDetails = () => {
    getEmployeeById(employeeId)
      .then((res) => {
        setEmployeeInformation(res.data as UpdateEmployee);
        setEmpName(res.data.name);
        setGenderValue(res.data.gender);
        setMaritalStatusValue(res.data.maritalStatus);
        setCarrierStartDate(
          moment(res.data?.carrierStartDate).format('YYYY-MM-DD')
        );
      })
      .catch(() => {
        navigate('/');
      });

    getEmployeeDesignationHistory(employeeId).then((res) => {
      setEmployeeDesigntionHistory(res.data as EmployeeDesignationHistory[]);
    });
  };

  const getAllManagers = async () => {
    const result = await getEmployeeManagers(employeeId);
    let filteredAdditionalsArray;
    let filteredMainsArray;
    if (result.data) {
      filteredAdditionalsArray = result?.data?.filter(
        (ele) => ele.level === 'additional'
      );
      filteredMainsArray = result?.data?.filter(
        (ele) => ele.level !== 'additional'
      );
    }

    let filteredTreeData;
    if (filteredMainsArray) {
      filteredTreeData = filteredMainsArray.map((manager) => {
        if (manager.level === 'primary') {
          return {
            title: manager.name,
            subtitle: 'Primary Reporting Manager'
          };
        }
        if (manager.level === 'secondary') {
          return {
            title: manager.name,
            subtitle: 'Secondary Reporting Manager',
            children: filteredAdditionalsArray.map((additional) => {
              return {
                title: additional.name,
                subtitle: 'Additional Reporting Manager'
              };
            })
          };
        }
      });
    }

    setTreeData(
      filteredTreeData &&
        filteredTreeData.sort((x, y) =>
          x.subtitle === 'Primary Reporting Manager'
            ? -1
            : y.subtitle === 'Primary Reporting Manager'
            ? 1
            : 0
        )
    );
  };

  useEffect(() => {
    getAllGenderDetails();
    getAllMartialStatusDetails();
  }, []);

  const getAllGenderDetails = () => {
    getAllGenders().then((res) => {
      setAllGenders(
        res?.data.map((ele) => {
          return { title: ele.name, id: ele.id };
        })
      );
    });
  };

  const getAllMartialStatusDetails = () => {
    getAllMartialStatus().then((res) => {
      setAllMaritalStatus(
        res?.data.map((ele) => {
          return { title: ele.name, id: ele.id };
        })
      );
    });
  };

  const getAllPageData = () => {
    dispatch(AppActions.showLoader());
    getEmplyeeDetails();
    getEmployeeImages();
    getAllManagers();
    dispatch(AppActions.hideLoader());
  };

  useEffect(() => {
    getAllPageData();
  }, []);

  const CardHeaderWrapper = styled(CardHeader)(
    () => `
    .MuiCardHeader-action{
      width: 100%
    }
  `
  );

  useEffect(() => {
    if (tableId) {
      if (image) {
        uploadEmployeeImageById(tableId, image.file, getEmplyeeDetails);
      }
    }
  }, [tableId]);

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(email)) {
      //Email valid. Procees to test if it's from the right domain (Second argument is to check that the string ENDS with this domain, and that it doesn't just contain it)
      if (
        email.indexOf(
          '@digiratina.com',
          email.length - '@digiratina.com'.length
        ) !== -1
      ) {
        //VALID
        return true;
      } else {
        return false;
      }
    }
  };

  const onSubmit = () => {
    settableId(employeeId);
    const errorData: any = {};
    if (
      employeeInformation.name === '' ||
      employeeInformation.name?.trim()?.length < 1
    ) {
      errorData.nameError = 'Name required';
    }
    if (
      employeeInformation.nic === '' ||
      employeeInformation.nic?.trim()?.length < 1
    ) {
      errorData.nicError = 'NIC required';
    }
    if (employeeInformation.phoneNumber === '') {
      errorData.phoneNumberError = 'Phone Number required';
    }
    if (employeeInformation?.phoneNumber?.length < 10) {
      errorData.phoneNumberError = 'Phone number cannot be less than 10';
    }
    if (employeeInformation.emergencyPhoneNumber === '') {
      errorData.emergencyPhoneNumberError = 'Emergency Phone Number required';
    }
    if (employeeInformation?.emergencyPhoneNumber?.length < 10) {
      errorData.emergencyPhoneNumberError =
        'Emergency number cannot be less than 10';
    }
    if (
      employeeInformation.address === '' ||
      employeeInformation.address?.trim()?.length < 1
    ) {
      errorData.addressError = 'Address required';
    }
    if (
      employeeInformation.currentAddress === '' ||
      employeeInformation.currentAddress?.trim()?.length < 1
    ) {
      errorData.currentAddressError = 'Current Address required';
    }
    if (
      employeeInformation.skypeID === '' ||
      employeeInformation.skypeID?.trim()?.length < 1
    ) {
      errorData.skypeIDError = 'skypeID required';
    }
    if (
      employeeInformation.email === '' ||
      employeeInformation.email?.trim()?.length < 1
    ) {
      errorData.emailError = 'email required';
    }
    if (!validateEmail(employeeInformation.email)) {
      errorData.emailError = 'Please enter valid email address';
    }

    setErrors(errorData);
    if (Object.keys(errorData).length === 0) {
      dispatch(AppActions.showLoader());
      const payload: UpdateEmployeeProfile = {
        employeeId: employeeId,
        name: employeeInformation.name,
        nic: employeeInformation.nic,
        gender: employeeInformation.gender,
        materialStatus: employeeInformation.maritalStatus,
        dob: employeeInformation.dob,
        phone: employeeInformation.phoneNumber,
        emergencyPhone: employeeInformation.emergencyPhoneNumber,
        address: employeeInformation.address,
        currentAddress: employeeInformation.currentAddress,
        skypeID: employeeInformation.skypeID,
        officeEmailAddress: employeeInformation.email,
        genderId: genders.find((obj) => obj.title === genderValue)?.id,
        materialStatusId: maritalStatus.find(
          (obj) => obj.title === maritalStatusValue
        )?.id
      };
      updateEmployeeInformationProfile(payload, settableId)
        .then((res) => {
          setEmployeeInformation(res.data as UpdateEmployee);
          setEmpName(res.data.name);
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: 'Employee Updated Successfully',
              severity: 'success'
            })
          );
          getEmplyeeDetails();
          setEmplyeeImages(emplyeeImages.slice(0, -1));
          getEmployeeImages();
          setIsEdit(false);
          getAllManagers();
          dispatch(AppActions.hideLoader());
        })
        .catch(() => {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: 'Unable to Edit the Employee',
              severity: 'error'
            })
          );
          dispatch(AppActions.hideLoader());
        });
    }
  };

  useEffect(() => {
    if (designation.length !== reversedDesignation.length)
      setreversedDesignation(designation.reverse());
  }, [designation, reversedDesignation.length]);

  useEffect(() => {
    if (!employeeInformation.dob) {
      setEmployeeInformation({
        ...employeeInformation,
        dob: '2022-01-01'
      });
    }
  }, [employeeInformation]);

  const onlyAlphanumericRegex = /[^a-z0-9]/gi;
  const [errors, setErrors] = useState<any>({});
  const [image, setImage] = useState<any>({});

  const handleImageChange = (event) => {
    const fileSize = (event.target.files[0].size / 1024 / 1024).toFixed(4);
    const imageName = event.target.files[0].name;
    const extensionsRegex = /(\.jpg|\.jpeg|\.bmp|\.gif|\.png)$/i;

    if (Number(fileSize) > 10) {
      setErrors((prev) => ({
        ...prev,
        imageError: 'Maximum file size exceeded.'
      }));
    } else if (!extensionsRegex.exec(imageName)) {
      setErrors((prev) => ({
        ...prev,
        imageError: 'File format is incorrect. Please check and try again.'
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        imageError: ''
      }));
      setImage({ file: event.target.files[0] });
    }
  };

  const oneYearAfter = new Date();
  oneYearAfter.setFullYear(oneYearAfter.getFullYear() + 1);

  const newDesignationArray = reversedDesignation.map((obj) => {
    return {
      ...obj,
      name: obj.name,
      startedDate: obj.startedDate,
      endDate: obj.endDate,
      duration: obj.duration,
      endDateByOrder: obj.endDate ? obj.endDate : oneYearAfter
    };
  });

  const sortEndDates = newDesignationArray
    .map((obj) => {
      return { ...obj, endDateByOrder: new Date(obj.endDateByOrder) };
    })
    .sort((a, b) => b.endDateByOrder - a.endDateByOrder);

  const CustomTableRow = withStyles({
    root: {
      height: '2.5rem',
      backgroundColor: '#E6E9FF !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer'
    }
  })(Card);
  const [isExpandGeneralDetails, setIsExpandGeneralDetails] =
    useState<boolean>(true);
  const [isExpandContactDetails, setIsExpandContactDetails] =
    useState<boolean>(false);
  const [companyExperience, setCompanyExperience] = useState('');
  const [carrierFullExperience, setCarrierFullExperience] = useState('');
  const [carrierStartDate, setCarrierStartDate] = useState('');

  const convertDuration = (duration) => {
    const parts = duration.split(' ');
    const yearsIndex = parts.findIndex(
      (part) => part === 'year' || part === 'years'
    );
    const monthsIndex = parts.findIndex(
      (part) => part === 'month' || part === 'months'
    );

    let years = 0;
    let months = 0;
    if (yearsIndex !== -1) {
      years = parseInt(parts[yearsIndex - 1]) || 0;
    }
    if (monthsIndex !== -1) {
      months = parseInt(parts[monthsIndex - 1]) || 0;
    }

    let convertedDuration = '';
    if (years > 0) {
      convertedDuration += years > 1 ? `${years} yrs ` : `${years} yr `;
    }
    if (months > 0) {
      convertedDuration += months > 1 ? `${months} mos` : `${months} mo`;
    }
    return convertedDuration.trim();
  };

  useEffect(() => {
    let endDate = moment().format('YYYY-MM-DD');
    let startDate = getCompanyStartDate(designation);
    const rangeExperience = calculateCompanyExperience(startDate, endDate);
    setCompanyExperience(rangeExperience);
  }, [designation]);

  const calculateCompanyExperience = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate);

    const years = end.diff(start, 'years');
    start.add(years, 'years');
    const months = end.diff(start, 'months');

    let convertedDuration = '';
    if (years > 0) {
      convertedDuration += years > 1 ? `${years} yrs ` : `${years} yr `;
    }
    if (months > 0) {
      convertedDuration += months > 1 ? `${months} mos` : `${months} mo`;
    }
    return convertedDuration.trim();
  };

  const getCompanyStartDate = (employDesignation) => {
    let companyStartDate = null;

    employDesignation.forEach((record) => {
      const startDate = moment(record.startedDate, 'YYYY.MM.DD');
      if (!companyStartDate || startDate < companyStartDate) {
        companyStartDate = startDate;
      }
    });

    return companyStartDate?.format('YYYY-MM-DD');
  };

  const formatDate = (dateString) => {
    return moment(dateString, 'YYYY.MM.DD').format('MMM YYYY');
  };

  useEffect(() => {
    let endDate = moment().format('YYYY-MM-DD');
    const rangeExperience = calculateCompanyExperience(
      carrierStartDate,
      endDate
    );
    setCarrierFullExperience(rangeExperience);
  }, [carrierStartDate]);

  const [value, settValue] = useState<any>(tabIds[0]);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    settValue(newValue);
  };

  // Find the acknowledgement task from employeeInformation or another relevant source
  const ackTask =
    employeeInformation?.onboardingTasks?.find?.(
      (t: any) => t.name === 'Acknowledgement'
    ) || null;

  const items = ackTask?.subTaskDetails?.length
    ? ackTask.subTaskDetails.map((s: any) => ({
        id: s.id,
        label: s.name,
        checked: s.status === 'COMPLETED',
        viewUrl: s.documentUrl || '#'
      }))
    : [
        { id: 'nda', label: 'NDA', checked: true, viewUrl: '#' },
        {
          id: 'aup',
          label: 'AUP (Acceptable Usage Policy)',
          checked: true,
          viewUrl: '#'
        },
        {
          id: 'privacy',
          label: 'Privacy Policy and Privacy Note',
          checked: true,
          viewUrl: '#'
        },
        {
          id: 'consent',
          label: 'Digiratina Consent Form',
          checked: true,
          viewUrl: '#'
        }
      ];

  return (
    <>
      <Grid container direction={'row'} sx={{ py: 2, px: 3 }}>
        <Grid item>
          <Typography variant="h4" component="h4">
            My Profile
          </Typography>
        </Grid>
      </Grid>
      <Container maxWidth="xl" className="my-profile">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card
              className="hideScroll"
              sx={{ height: 'auto', overflowY: 'hidden' }}
            >
              <Box sx={{ width: '100%' }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="wrapped label tabs example"
                >
                  <Tab value="one" label="Profile Details" />
                  <Tab value="two" label="Project Details" />
                  <Tab value="three" label="Leave History" />
                  <Tab value="four" label="Events" />
                </Tabs>
              </Box>

              {value === tabIds[0] ? (
                <>
                  <CardHeaderWrapper />

                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      md={4}
                      sx={{
                        pl: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        height: 'fit-content',
                        borderRight: '1px solid rgba(34, 51, 84, 0.1)'
                      }}
                    >
                      <Grid item>
                        <Grid
                          item
                          sx={{ display: 'flex', pt: 1, pl: 1, mb: 2 }}
                        >
                          <img
                            alt="logo"
                            style={{
                              marginTop: -15,
                              objectFit: 'cover',
                              width: '72px',
                              height: '72px',
                              borderRadius: '50%'
                            }}
                            src={
                              emplyeeImages[0]?.image ||
                              process.env.PUBLIC_URL + '/img/user.png'
                            }
                          />
                          <Grid item sx={{ pl: 2 }}>
                            <Typography variant="h4">{empName}</Typography>
                            <Typography
                              variant="h5"
                              style={{ fontWeight: 'normal' }}
                            >
                              {employeeInformation.designation}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Divider />
                        <Grid
                          style={{
                            marginLeft: '9px',
                            marginBottom: '1.5rem',
                            marginTop: '0.5rem',
                            display: 'flex'
                          }}
                        >
                          <Grid>
                            <Grid
                              style={{ fontSize: '14px', fontWeight: 'bold' }}
                            >
                              Career Full Experience
                            </Grid>
                            <Grid style={{ fontSize: '13px' }}>
                              {carrierFullExperience
                                ? carrierFullExperience
                                : 'No experience'}
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid style={{ marginLeft: '9px', display: 'flex' }}>
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              '/img/digiratina-logo.png'
                            }
                            alt="digiratina-logo"
                            style={{ width: '3rem', height: '3rem' }}
                          />
                          <Grid style={{ marginLeft: '1rem' }}>
                            <Grid
                              style={{ fontSize: '14px', fontWeight: 'bold' }}
                            >
                              Digiratina
                            </Grid>
                            <Grid style={{ fontSize: '13px' }}>
                              {companyExperience
                                ? companyExperience
                                : 'No experience'}
                            </Grid>
                          </Grid>
                        </Grid>
                        <Timeline
                          style={{ marginTop: '-4px', marginLeft: '15px' }}
                        >
                          {(sortEndDates || []).map((item, i) => {
                            return (
                              <>
                                <TimelineItem>
                                  <TimelineSeparator>
                                    {item.endDate === null ? (
                                      <TimelineDot
                                        color="success"
                                        style={{ marginTop: '-14px' }}
                                      />
                                    ) : (
                                      <TimelineDot
                                        style={{ marginTop: '-14px' }}
                                      />
                                    )}
                                    <TimelineConnector
                                      sx={{
                                        marginTop: '20px',
                                        height: `${
                                          i === sortEndDates.length - 1
                                            ? '0%'
                                            : '100%'
                                        }`
                                      }}
                                    />
                                  </TimelineSeparator>
                                  <TimelineContent>
                                    <Typography
                                      sx={{
                                        fontSize: '13px',
                                        fontWeight: 'bold'
                                      }}
                                      variant="h5"
                                    >
                                      {item.name}
                                    </Typography>
                                    {item.endDate === null ? (
                                      <Typography
                                        fontWeight="light"
                                        display="block"
                                        sx={{ fontSize: '12px' }}
                                      >
                                        {formatDate(item.startedDate)} - Present{' '}
                                        {item.duration != '' && (
                                          <span>
                                            {' - ' +
                                              convertDuration(item.duration)}
                                          </span>
                                        )}
                                      </Typography>
                                    ) : (
                                      <Typography
                                        color="GrayText"
                                        fontWeight="light"
                                        display="block"
                                        sx={{ fontSize: '12px' }}
                                      >
                                        {formatDate(item.startedDate)} -{' '}
                                        {formatDate(item.endDate)}{' '}
                                        {item.duration != '' && (
                                          <span>
                                            {' - ' +
                                              convertDuration(item.duration)}
                                          </span>
                                        )}
                                      </Typography>
                                    )}
                                  </TimelineContent>
                                </TimelineItem>
                              </>
                            );
                          })}
                        </Timeline>
                      </Grid>
                      <Divider />
                      <Typography
                        style={{ fontSize: '14px' }}
                        variant="h4"
                        sx={{ ml: 1, mt: 2, mb: 2 }}
                      >
                        Reporting Managers
                      </Typography>
                      {treeData?.length > 0 && (
                        <Grid container spacing={2} sx={{ marginBottom: 3 }}>
                          <SortableTree
                            treeData={treeData}
                            onChange={(treeData) => setTreeData(treeData)}
                            isVirtualized={false}
                            canDrag={false}
                            generateNodeProps={(row) => {
                              return {
                                style: {
                                  borderLeft: `3px solid ${
                                    row.treeIndex === 0
                                      ? '#3CB371'
                                      : row.treeIndex === 1
                                      ? '#0000FF'
                                      : '#FFD700'
                                  }`
                                },
                                title: (
                                  <div
                                    style={{
                                      fontSize: '11px',
                                      fontWeight: 'normal'
                                    }}
                                  >
                                    {row.node.subtitle}
                                  </div>
                                ),
                                subtitle: (
                                  <div
                                    style={{
                                      lineHeight: '2em',
                                      fontSize: '13px',
                                      fontWeight: '700'
                                    }}
                                  >
                                    {row.node.title}
                                  </div>
                                )
                              };
                            }}
                          />
                        </Grid>
                      )}
                      <Divider />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={8}
                      style={{
                        overflow: 'auto',
                        paddingBottom: '30px',
                        paddingLeft: '1rem',
                        paddingRight: '1rem'
                      }}
                    >
                      <form>
                        <Grid>
                          <Grid
                            item
                            xs={12}
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-end'
                            }}
                          ></Grid>
                          <CustomTableRow
                            onClick={() =>
                              setIsExpandGeneralDetails(!isExpandGeneralDetails)
                            }
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <Typography
                                style={{
                                  color: 'white',
                                  fontWeight: '700',
                                  fontSize: '11px',
                                  marginLeft: '0.5rem',
                                  marginRight: '1rem',
                                  padding: '4px 9px',
                                  borderRadius: '50%',
                                  background: isExpandGeneralDetails
                                    ? '#5569ff'
                                    : '#A6ACAF'
                                }}
                              >
                                {'1'}
                              </Typography>
                              <Typography
                                style={{
                                  color: '#232C68',
                                  fontWeight: '700',
                                  fontSize: '12px'
                                }}
                              >
                                {'General Details'}
                              </Typography>
                            </div>
                            {isExpandGeneralDetails ? (
                              <ExpandLessIcon style={{ fontSize: '27px' }} />
                            ) : (
                              <ExpandMoreIcon style={{ fontSize: '27px' }} />
                            )}
                          </CustomTableRow>
                          {isExpandGeneralDetails ? (
                            <Grid style={{ marginBottom: '1rem' }}>
                              <Grid container spacing={2} sx={{ p: 1 }}>
                                <Grid item xs={6}>
                                  <FormControl fullWidth>
                                    <Typography
                                      style={{ fontSize: '13px' }}
                                      color="GrayText"
                                    >
                                      Employee Name
                                    </Typography>
                                    <TextField
                                      className="input-text"
                                      disabled={!isEdit}
                                      size="small"
                                      {...register('name')}
                                      placeholder="Employee Name"
                                      variant="outlined"
                                      value={employeeInformation.name}
                                      inputProps={{
                                        style: { fontSize: '13px' }
                                      }}
                                      onChange={(e) => {
                                        if (e.target.value.length < 51) {
                                          setErrors((prev) => ({
                                            ...prev,
                                            nameError: ''
                                          }));
                                          setEmployeeInformation((prev) => ({
                                            ...prev,
                                            name: e.target.value
                                          }));
                                        }
                                      }}
                                    />
                                    {errors?.nameError && (
                                      <Typography
                                        style={{
                                          paddingLeft: 15,
                                          paddingRight: 15,
                                          fontSize: '11px'
                                        }}
                                        color="red"
                                      >
                                        {errors?.nameError}
                                      </Typography>
                                    )}
                                  </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography
                                    style={{ fontSize: '13px' }}
                                    color="GrayText"
                                  >
                                    NIC
                                  </Typography>
                                  <TextField
                                    className="input-text"
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled={!isEdit}
                                    {...register('nic')}
                                    size="small"
                                    fullWidth
                                    placeholder="NIC Number"
                                    variant="outlined"
                                    value={employeeInformation.nic}
                                    onChange={(e) => {
                                      e.target.value = e.target.value.replace(
                                        onlyAlphanumericRegex,
                                        ''
                                      );
                                      if (e.target.value.length < 13) {
                                        setErrors((prev) => ({
                                          ...prev,
                                          nicError: ''
                                        }));
                                        setEmployeeInformation((prev) => ({
                                          ...prev,
                                          nic: e.target.value
                                        }));
                                      }
                                    }}
                                  />
                                  {errors?.nicError && (
                                    <Typography
                                      style={{
                                        paddingLeft: 15,
                                        paddingRight: 15,
                                        fontSize: '11px'
                                      }}
                                      color="red"
                                    >
                                      {errors?.nicError}
                                    </Typography>
                                  )}
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography
                                    style={{ fontSize: '13px' }}
                                    color="GrayText"
                                  >
                                    Gender
                                  </Typography>
                                  {!isEdit ? (
                                    <TextField
                                      className="input-text"
                                      inputProps={{
                                        style: { fontSize: '13px' }
                                      }}
                                      disabled={!isEdit}
                                      size="small"
                                      fullWidth
                                      variant="outlined"
                                      value={genderValue}
                                    />
                                  ) : (
                                    <Select
                                      className="select-text text-primary"
                                      disabled={!isEdit}
                                      {...register('genderId')}
                                      size="small"
                                      fullWidth
                                      value={genderValue}
                                      onChange={(e) => {
                                        setGenderValue(e.target.value);
                                      }}
                                    >
                                      {genders.map((gnd) => (
                                        <MenuItem
                                          key={gnd.id}
                                          value={gnd.title}
                                        >
                                          {gnd.title}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  )}
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography
                                    style={{ fontSize: '13px' }}
                                    color="GrayText"
                                  >
                                    Marital Status
                                  </Typography>
                                  {!isEdit ? (
                                    <TextField
                                      className="input-text"
                                      inputProps={{
                                        style: { fontSize: '13px' }
                                      }}
                                      disabled={!isEdit}
                                      size="small"
                                      fullWidth
                                      variant="outlined"
                                      value={maritalStatusValue}
                                    />
                                  ) : (
                                    <Select
                                      className="select-text"
                                      disabled={!isEdit}
                                      {...register('maritalStatusId')}
                                      fullWidth
                                      size="small"
                                      label="Marital Status"
                                      value={maritalStatusValue}
                                      onChange={(e) => {
                                        setMaritalStatusValue(e.target.value);
                                      }}
                                    >
                                      {maritalStatus.map((ms) => (
                                        <MenuItem key={ms.id} value={ms.title}>
                                          {ms.title}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  )}
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography
                                    style={{ fontSize: '13px' }}
                                    className="lable-text"
                                    color="GrayText"
                                  >
                                    Date of Birth
                                  </Typography>
                                  <TextField
                                    className="input-text"
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled={!isEdit}
                                    {...register('dob')}
                                    value={moment(
                                      employeeInformation.dob
                                    ).format('YYYY-MM-DD')}
                                    fullWidth
                                    size="small"
                                    placeholder="DD/MM/YYYY"
                                    type="date"
                                    defaultValue="2022-01-01"
                                    InputLabelProps={{
                                      shrink: false
                                    }}
                                    onChange={(e) => {
                                      setEmployeeInformation((prev) => ({
                                        ...prev,
                                        dob: e.target.value
                                      }));
                                    }}
                                  />
                                </Grid>
                              </Grid>
                              <Fragment>
                                <Grid container spacing={2} sx={{ p: 1 }}>
                                  <Grid item xs={8}>
                                    <Typography
                                      style={{
                                        marginTop: '0.5rem',
                                        fontSize: '13px',
                                        fontFamily:
                                          'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                                      }}
                                      fontWeight="light"
                                      variant="h5"
                                    >
                                      Profile Photo
                                    </Typography>
                                    <TextField
                                      disabled={!isEdit}
                                      InputProps={{
                                        style: {
                                          fontSize: '12px',
                                          height: '2.25rem'
                                        }
                                      }}
                                      fullWidth
                                      size="small"
                                      placeholder="No image Selected"
                                      value={
                                        Object.keys(image).length === 0
                                          ? ''
                                          : image?.file?.name
                                      }
                                    />
                                    <p
                                      style={{
                                        marginLeft: '1rem',
                                        marginTop: 0,
                                        marginBottom: 0,
                                        fontSize: '0.6rem',
                                        height: '0rem'
                                      }}
                                    >
                                      Maximum file upload size: 10MB
                                    </p>
                                    {errors?.imageError && (
                                      <Typography
                                        style={{
                                          marginTop: 10,
                                          paddingLeft: 15,
                                          paddingRight: 15,
                                          fontSize: '11px'
                                        }}
                                        color="red"
                                      >
                                        {errors?.imageError}
                                      </Typography>
                                    )}
                                  </Grid>
                                  <Grid item xs={4}>
                                    <Button
                                      disabled={!isEdit}
                                      style={{
                                        marginTop: '1.6rem',
                                        border: '1px solid #5569ff',
                                        marginLeft: '-0.5rem',
                                        color: '#5569ff',
                                        padding: '6px 8px',
                                        borderRadius: '6px',
                                        fontSize: '13px',
                                        fontWeight: 'normal'
                                      }}
                                    >
                                      Choose
                                      <input
                                        type="file"
                                        name="attachment"
                                        id="upload-profile"
                                        accept="image/png, image/gif, image/jpeg"
                                        onChange={handleImageChange}
                                      />
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Fragment>
                            </Grid>
                          ) : (
                            <Grid
                              style={{
                                height: '1rem',
                                borderLeft: '1px solid #D5DBDB',
                                marginLeft: '1.3rem'
                              }}
                            ></Grid>
                          )}
                          <CustomTableRow
                            onClick={() =>
                              setIsExpandContactDetails(!isExpandContactDetails)
                            }
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <Typography
                                style={{
                                  color: 'white',
                                  fontWeight: '700',
                                  fontSize: '11px',
                                  marginLeft: '0.5rem',
                                  marginRight: '1rem',
                                  padding: '4px 9px',
                                  borderRadius: '50%',
                                  background: isExpandContactDetails
                                    ? '#5569ff'
                                    : '#A6ACAF'
                                }}
                              >
                                {'2'}
                              </Typography>
                              <Typography
                                style={{
                                  color: '#232C68',
                                  fontWeight: '700',
                                  fontSize: '12px'
                                }}
                              >
                                {'Contact Details'}
                              </Typography>
                            </div>
                            {isExpandContactDetails ? (
                              <ExpandLessIcon style={{ fontSize: '27px' }} />
                            ) : (
                              <ExpandMoreIcon style={{ fontSize: '27px' }} />
                            )}
                          </CustomTableRow>
                          {isExpandContactDetails && (
                            <Grid container spacing={2} sx={{ p: 1 }}>
                              <Grid item xs={6}>
                                <Typography
                                  style={{ fontSize: '13px' }}
                                  color="GrayText"
                                >
                                  Phone
                                </Typography>
                                {isEdit ? (
                                  <MuiPhoneNumber
                                    defaultCountry={'lk'}
                                    size="small"
                                    id="phone-number"
                                    {...register('phoneNumber', {})}
                                    InputProps={{
                                      style: {
                                        fontSize: '12px',
                                        height: '2.25rem'
                                      }
                                    }}
                                    fullWidth
                                    type="string"
                                    placeholder="Enter Phone"
                                    variant="outlined"
                                    value={employeeInformation.phoneNumber}
                                    onChange={(e) => {
                                      if (e.length < 16) {
                                        setErrors((prev) => ({
                                          ...prev,
                                          phoneNumberError: ''
                                        }));
                                        setEmployeeInformation((prev) => ({
                                          ...prev,
                                          phoneNumber: e
                                        }));
                                      }
                                    }}
                                  />
                                ) : (
                                  <TextField
                                    className="input-text"
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled
                                    {...register('phoneNumber')}
                                    size="small"
                                    fullWidth
                                    placeholder="Phone"
                                    type="string"
                                    variant="outlined"
                                    value={employeeInformation.phoneNumber}
                                  />
                                )}
                                {errors?.phoneNumberError && (
                                  <Typography
                                    style={{
                                      paddingLeft: 15,
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.phoneNumberError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  style={{ fontSize: '13px' }}
                                  color="GrayText"
                                >
                                  Emergency Phone
                                </Typography>
                                {isEdit ? (
                                  <MuiPhoneNumber
                                    defaultCountry={'lk'}
                                    size="small"
                                    id="emergency-number"
                                    {...register('emergencyPhoneNumber', {})}
                                    InputProps={{
                                      style: {
                                        fontSize: '12px',
                                        height: '2.25rem'
                                      }
                                    }}
                                    fullWidth
                                    type="string"
                                    placeholder="Emergency Phone"
                                    variant="outlined"
                                    value={
                                      employeeInformation.emergencyPhoneNumber
                                    }
                                    onChange={(e) => {
                                      if (e.length < 16) {
                                        setErrors((prev) => ({
                                          ...prev,
                                          emergencyPhoneNumberError: ''
                                        }));
                                        setEmployeeInformation((prev) => ({
                                          ...prev,
                                          emergencyPhoneNumber: e
                                        }));
                                      }
                                    }}
                                  />
                                ) : (
                                  <TextField
                                    className="input-text"
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled
                                    {...register('emergencyPhoneNumber')}
                                    size="small"
                                    fullWidth
                                    placeholder="Emergency Phone"
                                    variant="outlined"
                                    type="string"
                                    value={
                                      employeeInformation.emergencyPhoneNumber
                                    }
                                  />
                                )}
                                {errors?.emergencyPhoneNumberError && (
                                  <Typography
                                    style={{
                                      paddingLeft: 15,
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.emergencyPhoneNumberError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  style={{ fontSize: '13px' }}
                                  color="GrayText"
                                >
                                  Permanent Address
                                </Typography>
                                <TextField
                                  className="input-text"
                                  inputProps={{ style: { fontSize: '13px' } }}
                                  disabled={!isEdit}
                                  {...register('address')}
                                  size="small"
                                  fullWidth
                                  placeholder="Address"
                                  variant="outlined"
                                  value={employeeInformation.address}
                                  onChange={(e) => {
                                    setEmployeeInformation((prev) => ({
                                      ...prev,
                                      address: e.target.value
                                    }));
                                    setErrors((prev) => ({
                                      ...prev,
                                      address: ''
                                    }));
                                  }}
                                />
                                {errors?.addressError && (
                                  <Typography
                                    style={{
                                      paddingLeft: 15,
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.addressError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  style={{ fontSize: '13px' }}
                                  color="GrayText"
                                >
                                  Current Address
                                </Typography>
                                <TextField
                                  className="input-text"
                                  disabled={!isEdit}
                                  inputProps={{ style: { fontSize: '13px' } }}
                                  {...register('currentAddress')}
                                  size="small"
                                  fullWidth
                                  placeholder="Current Address"
                                  variant="outlined"
                                  value={employeeInformation.currentAddress}
                                  onChange={(e) => {
                                    setEmployeeInformation((prev) => ({
                                      ...prev,
                                      currentAddress: e.target.value
                                    }));
                                    setErrors((prev) => ({
                                      ...prev,
                                      currentAddressError: ''
                                    }));
                                  }}
                                />
                                {errors?.currentAddressError && (
                                  <Typography
                                    style={{
                                      paddingLeft: 15,
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.currentAddressError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  style={{ fontSize: '13px' }}
                                  color="GrayText"
                                >
                                  Skype ID
                                </Typography>
                                <TextField
                                  className="input-text"
                                  inputProps={{ style: { fontSize: '13px' } }}
                                  disabled={!isEdit}
                                  {...register('skypeID')}
                                  size="small"
                                  fullWidth
                                  placeholder="Skype ID"
                                  variant="outlined"
                                  value={employeeInformation.skypeID}
                                  onChange={(e) => {
                                    setEmployeeInformation((prev) => ({
                                      ...prev,
                                      skypeID: e.target.value
                                    }));
                                    setErrors((prev) => ({
                                      ...prev,
                                      skypeIDError: ''
                                    }));
                                  }}
                                />
                                {errors?.skypeIDError && (
                                  <Typography
                                    style={{
                                      paddingLeft: 15,
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.skypeIDError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  style={{ fontSize: '13px' }}
                                  color="GrayText"
                                >
                                  Official Email Address
                                </Typography>
                                <TextField
                                  inputProps={{ style: { fontSize: '13px' } }}
                                  className="input-text"
                                  disabled={!isEdit}
                                  {...register('email')}
                                  size="small"
                                  fullWidth
                                  placeholder="Email Address"
                                  variant="outlined"
                                  value={employeeInformation.email}
                                  onChange={(e) => {
                                    setEmployeeInformation((prev) => ({
                                      ...prev,
                                      email: e.target.value
                                    }));
                                    setErrors((prev) => ({
                                      ...prev,
                                      emailError: ''
                                    }));
                                  }}
                                />
                                {errors?.emailError && (
                                  <Typography
                                    style={{
                                      paddingLeft: 15,
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.emailError}
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </form>
                    </Grid>
                  </Grid>
                </>
              ) : value === tabIds[1] ? (
                <>
                  <EmployeeProjectDetails />
                </>
              ) : value === tabIds[2] ? (
                <>
                  <EmployeeLeaveSection />
                </>
              ) : value === tabIds[3] ? (
                <>
                  <ViewEventAttendee />
                </>
              ) : (
                <></>
              )}
            </Card>
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </>
  );
};

export default ProfilePage;
